import { EVENTS, trackEvent } from "./eventTracker";

const PENDING_KEY = "loaddash_pending_role_context_events_v1";
const ANONYMOUS_HAULER_EVENTS = new Set([
  EVENTS.HAULER_INTEREST,
  EVENTS.HAULER_APPLY_STARTED,
  EVENTS.HAULER_APPLY_COMPLETED,
]);

function readPendingEvents() {
  try {
    return JSON.parse(sessionStorage.getItem(PENDING_KEY) || "[]");
  } catch {
    return [];
  }
}

function writePendingEvents(events) {
  try {
    sessionStorage.setItem(PENDING_KEY, JSON.stringify(events.slice(-20)));
  } catch {}
}

function queueAnonymousEvent(eventType, metadata) {
  if (!ANONYMOUS_HAULER_EVENTS.has(eventType)) return;
  const pending = readPendingEvents();
  pending.push({
    event_type: eventType,
    occurred_at: new Date().toISOString(),
    metadata,
  });
  writePendingEvents(pending);
}

export function trackRoleContextEvent(eventType, userId = null, metadata = {}) {
  const roleContext = metadata.role_context || (metadata.intent === "hauler_interest" ? "hauler" : undefined);
  const enriched = {
    ...metadata,
    ...(roleContext ? { role_context: roleContext } : {}),
  };

  if (userId) {
    return trackEvent(eventType, userId, enriched);
  }

  queueAnonymousEvent(eventType, enriched);
}

export async function flushPendingRoleContextEvents(userId) {
  if (!userId) return;
  const pending = readPendingEvents();
  if (pending.length === 0) return;
  try {
    sessionStorage.removeItem(PENDING_KEY);
  } catch {}

  for (const event of pending) {
    await trackEvent(event.event_type, userId, {
      ...event.metadata,
      replayed_from_anonymous_session: true,
      original_occurred_at: event.occurred_at,
    });
  }
}

export { EVENTS };
